import { Text } from "@kvix/ui";
import React from "react";
import { FacebookProvider, Group } from "react-facebook";
import { useTranslation } from "react-i18next";

interface Props {
  groupId: string;
  isMobile?: boolean;
}

export const ProgramFacebookGroup: React.FC<Props> = (props) => {
  const { isMobile, groupId } = props;
  const { t, ready } = useTranslation("program");
  const groupUrl = `https://www.facebook.com/groups/${groupId}`;

  const SUM_OF_X_PADDINGS = 32 * 2;
  const GROUP_WIDGET_WIDTH = isMobile
    ? window.innerWidth - SUM_OF_X_PADDINGS
    : "350";

  if (!ready) {
    return null;
  }

  return (
    <>
      <Text variant="h4" gutterBottom>
        {t("facebookGroup.title")}
      </Text>
      <Text style={{ marginBottom: "18px" }}>
        {t("facebookGroup.description")}
      </Text>
      <FacebookProvider appId={window.config.FACEBOOK_APP_ID}>
        <Group
          href={groupUrl}
          width={GROUP_WIDGET_WIDTH}
          skin="light"
          showSocialContext={false}
        />
      </FacebookProvider>
    </>
  );
};
